// eslint-disable-next-line import/prefer-default-export
export enum PaymentMethodType {
    // Any enum added here should be added to the schema of the request where this enum is used. example: AppStartCharging, PostBoltStartChargingReq
    PaymentGateway = '10', // This covers all the payment done through CC, DC, UPI, Net Banking
    OTM = '15',
    Wallet = '20', // This covers all the payment done through Instacharge Wallet, Paytm Wallet, Shared Wallet
}
